import { render, staticRenderFns } from "./viewpregresshistory.vue?vue&type=template&id=0bda393e&scoped=true"
import script from "./viewpregresshistory.vue?vue&type=script&lang=js"
export * from "./viewpregresshistory.vue?vue&type=script&lang=js"
import style0 from "./viewpregresshistory.vue?vue&type=style&index=0&id=0bda393e&prod&scoped=true&lang=css"
import style1 from "./viewpregresshistory.vue?vue&type=style&index=1&id=0bda393e&prod&scoped=scoped&lang=scss"
import style2 from "./viewpregresshistory.vue?vue&type=style&index=2&id=0bda393e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda393e",
  null
  
)

export default component.exports